<template>
  <section class="passe-livre">
    <v-form
      ref="form"
      lazy-validation
      @submit.prevent="onSubmit"
    >
      <v-card
        outlined
        class="app-card"
      >
        <v-card-title class="app-card-title">
          {{ currentRouter === 'passe-livre-cadastro' ? 'Cadastro' : 'Editar' }}
          - Passe Livre Intermunicipal
        </v-card-title>
        <v-card-text class="app-card-content">
          <ul class="breadcrumbs-register">
            <li class="breadcrumbs-register__item breadcrumbs-register__item--active">
              1 - Beneficiário
            </li>
            <li class="breadcrumbs-register__item">
              2 - Confirmar
            </li>
          </ul>
          <v-row>
            <v-col
              :md="12"
              :sm="12"
              :xs="12"
              cols="12"
            >
              <input
                v-if="currentRouter === 'passe-livre-edit-cadastro'"
                v-model="form.id"
                type="hidden"
              >
              <v-text-field
                v-model="form.cpf"
                v-mask="'###.###.###-##'"
                placeholder="Digite seu cpf"
                label="CPF *"
                :rules="[rules.required, rules.cpf]"
                filled
                rounded
                dense
              />
            </v-col>
            <v-col
              :md="12"
              :sm="12"
              :xs="12"
              cols="12"
            >
              <v-text-field
                v-model="form.nome"
                placeholder="Digite seu nome"
                label="Nome Completo *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              />
            </v-col>
            <v-col
              :md="12"
              :sm="12"
              :xs="12"
              cols="12"
            >
              <v-text-field
                v-model="form.email"
                placeholder="Digite seu email"
                label="Email "
                :rules="[rules.email]"
                filled
                rounded
                dense
              />
            </v-col>
            <v-col
              :md="8"
              :sm="8"
              :xs="12"
              cols="12"
            >
              <v-text-field
                v-model="form.dataNascimento"
                v-mask="'##/##/####'"
                placeholder="Ex.: 17/04/1976"
                label="Data Nascimento *"
                :rules="[rules.required, rules.birth]"
                filled
                rounded
                dense
              />
            </v-col>
            <v-col
              :md="4"
              :sm="4"
              :xs="12"
              cols="12"
            >
              <label>Sexo *</label>
              <v-radio-group
                v-model="form.sexo"
                :rules="[rules.required]"
                row
                class="mt-0"
              >
                <v-radio
                  v-for="s in sexo"
                  :key="s.key"
                  :label="s.value"
                  :value="s.key"
                />
              </v-radio-group>
            </v-col>
            <v-col
              :md="6"
              :sm="6"
              :xs="12"
              cols="12"
            >
              <v-text-field
                v-model="form.numeroDocumento"
                v-mask="'#####################'"
                placeholder="Digite o número do documento"
                label="Documento "
                filled
                rounded
                dense
              />
            </v-col>
            <v-col
              :md="6"
              :sm="6"
              :xs="12"
              cols="12"
            >
              <v-text-field
                v-model="form.dataEmissaoDocumento"
                v-mask="'##/##/####'"
                placeholder="Ex.: 18/04/1996"
                label="Emissão Documento "
                filled
                rounded
                dense
              />
            </v-col>
            <v-col
              :md="6"
              :sm="6"
              :xs="12"
              cols="12"
            >
              <v-text-field
                v-model="form.orgaoEmissorDocumento"
                placeholder="Ex.: SSPDS"
                label="Órgão Emissor "
                filled
                rounded
                dense
                maxlength="10"
              />
            </v-col>
            <v-col
              :md="6"
              :sm="6"
              :xs="12"
              cols="12"
            >
              <v-autocomplete
                v-model="form.ufDocumento"
                :loading="loadingEstado"
                :items="estados"
                :search-input.sync="searchEstados"
                :item-text="'nome'"
                :item-value="'nome'"
                cache-items
                hide-no-data
                hide-details
                label="Uf Documento"
                placeholder="Selecione um Estado"
                filled
                rounded
                dense
              />
            </v-col>
            <v-col
              :md="12"
              :sm="12"
              :xs="12"
              cols="12"
            >
              <v-row>
                <v-col
                  :md="2"
                  :sm="2"
                  :xs="12"
                  cols="12"
                  class="pt-0"
                >
                  <div class="form-control mb-5">
                    <label for="ddd">DDD *</label>
                    <InputMask
                      id="ddd"
                      v-model="form.telefoneDdd"
                      placeholder="Ex.: 85"
                      mask-t="##"
                      :masked="true"
                    />
                  </div>
                </v-col>
                <v-col
                  :md="4"
                  :sm="4"
                  :xs="12"
                  cols="12"
                  class="pt-0"
                >
                  <div class="form-control mb-5">
                    <label for="telefone">Telefone *</label>
                    <InputMask
                      id="telefone"
                      v-model="form.telefoneNum"
                      placeholder="Ex.: 98755-9988"
                      mask-t="#####-####"
                      :masked="true"
                    />
                  </div>
                </v-col>
                <v-col
                  :md="2"
                  :sm="2"
                  :xs="12"
                  cols="12"
                  class="pt-0"
                >
                  <div class="form-control mb-5">
                    <label for="ddd2">DDD 2</label>
                    <InputMask
                      id="ddd2"
                      v-model="form.telefoneDdd2"
                      placeholder="Ex.: 85"
                      mask-t="##"
                    />
                  </div>
                </v-col>
                <v-col
                  :md="4"
                  :sm="4"
                  :xs="12"
                  cols="12"
                  class="pt-0"
                >
                  <div class="form-control mb-5">
                    <label for="telefone2">Telefone 2</label>
                    <InputMask
                      id="telefone2"
                      v-model="form.telefoneNum2"
                      placeholder="Ex.: 98755-9988"
                      mask-t="#####-####"
                      :masked="true"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              :md="12"
              :sm="12"
              :xs="12"
              cols="12"
            >
              <v-text-field
                v-model="form.nomeMae"
                placeholder="Ex.: Digite o nome da Mãe"
                label="Nome da Mãe *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              />
            </v-col>
            <v-col
              :md="12"
              :sm="12"
              :xs="12"
              cols="12"
            >
              <label>Necessita de Acompanhamente? *</label>
              <v-radio-group
                v-model="form.acompanhante"
                :rules="[rules.required]"
                row
                class="mt-0"
              >
                <v-radio
                  :key="3"
                  :label="`Sim`"
                  :value="'true'"
                />
                <v-radio
                  :key="4"
                  :label="`Não`"
                  :value="'false'"
                />
              </v-radio-group>
            </v-col>
            <p class="red--text mb-0 ml-5">
              *Caso ocorra a necessidade do acompanhante, deverá constar no laudo médico a
              informação sobre o mesmo.
            </p>
          </v-row>
          <div
            v-if="isLoading"
            class="loading"
          >
            <v-progress-circular
              :size="25"
              color="primary"
              indeterminate
            />
          </div>
        </v-card-text>
      </v-card>

      <v-card
        outlined
        class="app-card"
      >
        <v-card-title class="app-card-title">
          Endereço
        </v-card-title>
        <v-card-text class="app-card-content">
          <v-row>
            <v-col
              :md="12"
              :sm="12"
              :xs="12"
              cols="12"
            >
              <v-text-field
                v-model="form.cep"
                v-mask="'#####-###'"
                placeholder="Digite seu cep"
                label="Cep*"
                filled
                rounded
                dense
                masked="false"
                :loading="isLoadingCep"
                :rules="[rules.required, rules.cep]"
                @input="searchCep"
              >
                <template #progress>
                  <v-progress-circular
                    v-if="isLoadingCep"
                    indeterminate
                    color="primary"
                  />
                </template>
              </v-text-field>
            </v-col>

            <v-col
              :md="9"
              :sm="9"
              :xs="9"
              cols="12"
            >
              <v-text-field
                v-model="form.logradouro"
                placeholder="Ex.: Rua das Acácias"
                label="Logradouro *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              />
            </v-col>

            <v-col
              :md="2"
              :sm="2"
              :xs="9"
              cols="12"
            >
              <v-text-field
                v-model="form.numeroLogradouro"
                placeholder="Número Logradouro"
                label="Número"
                :disabled="form.enderecoSemNumero"
                :rules="[v => (form.enderecoSemNumero ? true : rules.numeroLogradouro(v))]"
                filled
                rounded
                dense
                @input="onNumeroLogradouroInput"
              />
            </v-col>

            <v-col
              :md="1"
              :sm="1"
              :xs="3"
              cols="12"
              class="d-flex align-center"
            >
              <v-checkbox
                v-model="form.enderecoSemNumero"
                label="S/N"
                dense
                hide-details
                @change="onToggleEnderecoSemNumero"
              />
            </v-col>

            <v-col
              :md="6"
              :sm="6"
              :xs="6"
              cols="12"
            >
              <v-text-field
                v-model="form.bairro"
                placeholder="Bairro"
                label="Bairro *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              />
            </v-col>
            <v-col
              :md="6"
              :sm="6"
              :xs="6"
              cols="12"
            >
              <v-text-field
                v-model="municipioDescricao"
                :rules="[rules.required]"
                label="Município *"
                placeholder="Município"
                filled
                rounded
                dense
                readonly
              />
            </v-col>
            <v-col
              :md="12"
              :sm="12"
              :xs="12"
              cols="12"
            >
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="siteKey"
                :load-recaptcha-script="true"
                @verify="verifyRecaptcha"
                @expired="expiredRecaptcha"
              />
              <v-input
                v-model="form.recaptcha"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <div
            v-if="isLoading"
            class="loading"
          >
            <v-progress-circular
              :size="25"
              color="primary"
              indeterminate
            />
          </div>
        </v-card-text>
      </v-card>

      <v-row>
        <v-col :md="2">
          <v-btn
            outlined
            block
            large
            color="primary"
            type="button"
            @click="backToLogin()"
          >
            Cancelar
          </v-btn>
        </v-col>
        <v-col
          :md="2"
          :offset-md="8"
        >
          <v-btn
            v-if="currentRouter === 'passe-livre-edit-cadastro'"
            depressed
            block
            large
            color="primary"
            type="submit"
            class=""
          >
            Salvar Alterações
          </v-btn>
          <v-btn
            v-else
            depressed
            block
            large
            color="primary"
            type="submit"
          >
            Continuar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </section>
</template>

<script>
import Vue from 'vue';
import { mask } from 'vue-the-mask';
import VueRecaptcha from 'vue-recaptcha';
import { VUE_APP_RECAPTCHA_KEY } from '@/commons/config';
import BeneficiarioService from '@/services/beneficiario.service';
import BeneficiarioAuthService from '@/services/beneficiario.auth.service';
import EstadoService from '@/services/estado.service';
import MunicipioService from '@/services/municipio.service';
import BeneficiarioStore from '@/store/modules/beneficiario';
import { validateCpf } from '@/helpers/cpf.validator';
import { Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, map, switchMap, delay, catchError  } from 'rxjs/operators';
import CepService from '@/services/cep.service';
import moment from 'moment';

import InputMask from '@/components/form/InputMask';
import { maskT } from '@/directives/mask';
import { checkDate } from '@/util/validate';
import { mapState } from 'vuex';
import { format } from 'crypto-js';
import GlobalStore from '@/store/modules/global';

export default Vue.extend({
  name: 'CadastroForm',
  components: {
    VueRecaptcha,
    InputMask,
  },
  directives: {
    mask,
    maskT,
  },
  data() {
    return {
      currentRouter: null,
      isLoadingCep: false,
      patternCep: /^[0-9]{2}[0-9]{3}-[0-9]{3}$/,
      subjectCep: null,
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      estados: [],
      loadingEstado: false,
      searchEstados: null,
      itemsEstados: [],
      municipios: [],
      municipioDescricao: null,
      sexo: [
        { key: 1, value: 'Masculino' },
        { key: 2, value: 'Feminino' },
      ],
      form: {
        id: null,
        cpf: null,
        nome: null,
        dataNascimento: null,
        sexo: null,
        numeroDocumento: '',
        dataEmissaoDocumento: '',
        orgaoEmissorDocumento: '',
        ufDocumento: '',
        telefoneDdd: null,
        telefoneNum: null,
        telefoneDdd2: null,
        telefoneNum2: null,
        acompanhante: null,
        cep: null,
        logradouro: null,
        numeroLogradouro: null,
        enderecoSemNumero: false,
        bairro: null,
        recaptcha: null,
        municipio: {
          id: null,
          estado: {
            id: 1,
          },
        },
        municipioIbge: null,
      },
      beneficiario: null,
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido',
        cpf: value => !!validateCpf(value) || 'CPF inválido',
        cep: value => {
          const pattern = this.patternCep;
          return pattern.test(value) || 'Cep inválido.';
        },
        birth: value => !!checkDate(value) || 'Data de Nascimento inválida',
        numeroLogradouro: value => {
          if (!value || value === null || value === '') return true;
          if (value === 'S/N' || value === 's/n') return true;
          return /^\d+$/.test(value) || 'Digite apenas números ou S/N';
        },
        email: value => {
          if (!value || value === '') return true;
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i;
          return pattern.test(value) || 'Email inválido';
        },
      },
      onNumeroLogradouroInput(value) {
        if (this.form.enderecoSemNumero) return;

        if (!value || value === '') {
          this.form.numeroLogradouro = null;
          return;
        }
        if (/^\d+$/.test(value)) {
          this.form.enderecoSemNumero = false;
          this.form.numeroLogradouro = value;
        } else if (String(value).toUpperCase() === 'S/N') {
          this.form.enderecoSemNumero = true;
          this.form.numeroLogradouro = null;
        } else {
          const cleaned = String(value).replace(/[^\d]/g, '');
          this.form.numeroLogradouro = cleaned;
        }
      },
    };
  },
  computed: {
    ...mapState({
      beneficiarioData: state => state.beneficiario.beneficiarioCpfNascimento,
    }),
  },
  watch: {
    searchEstados(val) {
      val && val !== this.form.ufDocumento && this.querySelectionsEstados(val);
    },
    'form.dataNascimento'(val) {
      if (val) {
        this.form.dataNascimento = val;
      }
    },
    'form.municipio.id'(val) {
      if (!val) {
        return;
      }

      const municipio = this.municipios.find(m => Number(m.id) === Number(val));
      if (municipio) {
        this.form.municipioIbge = municipio.ibge;
        this.municipioDescricao = municipio.nome || null;
      }
    },
  },
  mounted() {
    this.getCurrentRouter();
    this.loadBeneficiario();
    this.cepSubject();
    this.loadEstados();
    this.loadMunicipios();
    this.loadCpfNascimento();
    this.toTop();
  },
  methods: {
    clearAddressFromCep() {
      this.form.logradouro = null;
      this.form.bairro = null;
      this.form.municipioIbge = null;
      this.municipioDescricao = null;
      if (this.form.municipio && 'id' in this.form.municipio) {
        this.form.municipio.id = null;
      }
    },
    normalizeMunicipioNome(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toUpperCase();
    },
    findMunicipioByNome(nome) {
      const nomeNormalizado = this.normalizeMunicipioNome(nome);
      if (!nomeNormalizado) {
        return null;
      }

      return (
        this.municipios.find(
          municipio => this.normalizeMunicipioNome(municipio.nome) === nomeNormalizado
        ) || null
      );
    },
    onToggleEnderecoSemNumero() {
      if (this.form.enderecoSemNumero) {
        this.form.numeroLogradouro = null;
      }
    },

    toTop() {
      this.$vuetify.goTo(0);
    },
    loadBeneficiario(activeSnackbar = false) {
      const beneficiario = BeneficiarioAuthService.currentBeneficiarioValue();
      if (this.currentRouter === 'passe-livre-edit-cadastro') {
        BeneficiarioAuthService.searchUser(
          this.removeMask(beneficiario.cpf),
          beneficiario.dataNascimento
        ).subscribe(res => {
          if (activeSnackbar) {
            GlobalStore.setSnackBar({
              type: 'success',
              message: 'Cadastro atualizado com sucesso!',
              show: true,
            });
            this.beneficiario = res;
          } else {
            GlobalStore.setSnackBar({
              type: '',
              message: '',
              show: false,
            });
            this.beneficiario = res;
            this.setForm();
          }
        });
      }
    },
    setForm() {
      if (this.currentRouter === 'passe-livre-edit-cadastro' && this.beneficiario) {
        this.form.id = this.beneficiario.id;
        this.form.cpf = this.beneficiario.cpf;
        this.form.email = this.beneficiario.email;
        this.form.dataNascimento = moment(this.beneficiario.dataNascimento, 'YYYY-MM-DD').format(
          'DD/MM/YYYY'
        );
        this.form.nome = this.beneficiario.nome;
        this.form.sexo = Number(this.beneficiario.sexoId);
        this.form.numeroDocumento = this.beneficiario.numeroDocumento;
        this.form.ufDocumento = this.beneficiario.ufDocumento;
        this.form.orgaoEmissorDocumento = this.beneficiario.orgaoEmissorDocumento;
        this.form.dataEmissaoDocumento = this.beneficiario.dataEmissaoDocumento
          ? moment(this.beneficiario.dataEmissaoDocumento, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : '';
        this.form.telefoneDdd = this.beneficiario.dddTelefone;
        this.form.telefoneNum = this.beneficiario.telefone;
        this.form.telefoneDdd2 = this.beneficiario.dddTelefone2;
        this.form.telefoneNum2 = this.beneficiario.telefoneNum2;
        this.form.nomeMae = this.beneficiario.nomeMae;
        this.form.acompanhante = String(this.beneficiario.acompanhante);

        this.form.cep = this.beneficiario.cep;
        this.form.logradouro = this.beneficiario.logradouro;

        const n = Number(this.beneficiario.numeroLogradouro);
        this.form.enderecoSemNumero = n === 0;
        this.form.numeroLogradouro = this.form.enderecoSemNumero ? null : this.beneficiario.numeroLogradouro;

        this.form.bairro = this.beneficiario.bairro;
        this.form.municipio.id = this.beneficiario.municipio.id;
        this.municipioDescricao =
          this.beneficiario.cidade || this.beneficiario.municipio?.nome || null;

        if (this.beneficiario.telefones && this.beneficiario.telefones.length) {
          this.form.telefones = this.beneficiario.telefones;
        }

        this.isLoading = false;
      }
    },
    getCurrentRouter() {
      this.currentRouter = this.$route.name;
    },
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      const body = {
        ...this.form,
        cpf: this.removeMask(this.form.cpf),
        cep: this.removeMask(this.form.cep),
        telefoneDdd: this.removeMask(this.form.telefoneDdd),
        telefoneNum: this.removeMask(this.form.telefoneNum),
        telefoneDdd2: this.removeMask(this.form.telefoneDdd2),
        telefoneNum2: this.removeMask(this.form.telefoneNum2),
        dataNascimento: this.formatDate(this.form.dataNascimento),
        dataEmissaoDocumento: this.formatDate(this.form.dataEmissaoDocumento),

        numeroLogradouro: this.form.enderecoSemNumero
          ? 0
          : !this.form.numeroLogradouro || this.form.numeroLogradouro === ''
          ? null
          : this.form.numeroLogradouro === 'S/N' || this.form.numeroLogradouro === 's/n'
          ? 0
          : this.form.numeroLogradouro,
      };

      if (isValid) {
        if (this.currentRouter === 'passe-livre-edit-cadastro') {
          const { processo } = this.$route.params;
          BeneficiarioService.update(processo, body).subscribe(
            response => {
              BeneficiarioAuthService.setSessionFromRegister(this.beneficiario);
              this.isLoading = false;
              this.$vuetify.goTo(100);

              console.log(response)
              this.loadBeneficiario(true);

            },
            error => {
              this.isLoading = false;
            }
          );
        } else {
          delete body.municipio;
          delete body.recaptcha;
          delete body.id;
          BeneficiarioService.create(body).subscribe(
            res => {
              BeneficiarioAuthService.setSessionFromRegister(res);
              this.isLoading = false;
              this.$refs.recaptcha.reset();
              this.$vuetify.goTo(100);
            },
            error => {
              this.isLoading = false;
            }
          );
        }
      }
    },
    removeMask(value) {
      return value ? value.replace(/\D+/g, '') : null;
    },
    formatDate(value) {
      const data = moment(value, 'DD/MM/YYYY', true);
      return value ? moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
    },
    loadCpfNascimento() {
      const data = BeneficiarioAuthService.currentCpfNascimentoValue();
      if (data) {
        this.form.cpf = data.cpf;
        this.form.dataNascimento = moment(data.dataNascimento, 'YYYY-MM-DD').format('DD/MM/YYYY');
      }
    },
    backToLogin() {
      if (this.$route.name === 'passe-livre-edit-cadastro') {
        this.$router.push({
          name: 'passe-livre-detalhe',
          params: { id: this.beneficiario.id },
        });
      } else {
        this.$router.push({ name: 'passe-livre' });
      }
    },
    loadEstados() {
      BeneficiarioService.getAllEstados().subscribe(
        response => {
          this.estados = response;
        },
        error => {}
      );
    },
    loadMunicipios() {
      BeneficiarioService.getAllMunicipios().subscribe(
        response => {
          this.municipios = response;
        },
        error => {}
      );
    },
    searchCep(value) {
      this.subjectCep.next(value);
    },
    cepSubject() {
      this.subjectCep = new Subject();
      this.subjectCep
        .pipe(debounceTime(500))
        .pipe(
          distinctUntilChanged(
            (prev, curr) => this.removeMask(prev) === this.removeMask(curr)
          )
        )
        .pipe(tap(value => (this.isLoadingCep = true)))
        .pipe(
          switchMap(value => {
            const cepSemMascara = this.removeMask(value);
            const pattern = this.patternCep;
            const validCep = pattern.test(value);
                    
            if (!validCep) {
              return of({ error: 'Cep invalido' });
            }
          
            return BeneficiarioService.searchCep(cepSemMascara).pipe(
              catchError(() => of({ error: 'Cep invalido' }))
            );
          })
        )
        .pipe(delay(500))
        .subscribe(
          res => {
            this.isLoadingCep = false;
            if (res?.error) {
              this.clearAddressFromCep();
              return;
            }
            if (!res.error) {
              const { logradouro, localidade, bairro, ibge } = res;

              if (logradouro) {
                this.form.logradouro = logradouro;
              }

              if (bairro) {
                this.form.bairro = bairro;
              }
              if (ibge) {
                this.form.municipioIbge = ibge;
              }

              this.municipioDescricao = localidade || null;

              const municipio = this.findMunicipioByNome(localidade);
              this.form.municipio.id = municipio ? municipio.id : null;

              if (!ibge && municipio) {
                this.form.municipioIbge = municipio.ibge;
              }
            }
          },
          error => {
            this.isLoadingCep = false;
          }
        );
    },
    querySelectionsEstados(v) {
      this.loadingEstado = true;
      this.itemsEstados = this.estados.filter(e => {
        return (e.nome || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1;
      });
      this.loadingEstado = false;
    },
  },
});
</script>

<style scoped lang="scss">
.breadcrumbs-register {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 5px;
  padding: 0px;
  margin-bottom: 25px;

  &__item {
    padding: 10px;
    list-style: none;
    background-color: #ededed;
    display: flex;
    flex: 1;
    text-transform: uppercase;
    text-align: center;
    font-size: 17px;
    justify-content: center;
    color: #2e70b6;
    position: relative;
    padding-left: 30px;
    &:last-child {
      margin-right: 13px;
    }
    &:after {
      position: absolute;
      display: block;
      border: 21px solid transparent;
      border-left: 16px solid #ededed;
      border-right: 0;
      top: 0px;
      z-index: 10;
      content: '';
      right: -15px;
    }
    &--active {
      background-color: #2e70b6;
      color: #fff;
      &:after {
        border-left-color: #2e70b6;
      }
    }
  }
}
.v-progress-circular {
  height: 22px !important;
  width: 22px !important;
  top: 16px !important;
}
.alert {
  &-title {
    margin: 0px 0px 5px;
    font-weight: 500 !important;
    font-size: 17px !important;
  }
  &-list {
    &__item {
      margin-bottom: 5px;
    }
  }
}
</style>
